import React from "react";
import { FeaturesReady, GrowthBookProvider } from "@growthbook/growthbook-react";

import { growthbook, updateAttributes } from "./lib/growthbook";

const GrowthBookWrapper = ({ children }: React.PropsWithChildren) => {
  React.useEffect(() => {
    updateAttributes();
    growthbook.init();
  }, []);
  return (
    <GrowthBookProvider growthbook={growthbook}>
      <FeaturesReady timeout={1000}>{children}</FeaturesReady>
    </GrowthBookProvider>
  );
};

export default GrowthBookWrapper;
